import { z } from 'zod';
import {
  BullMQPayloadBaseSchema,
  JobRedisStateBaseSchema,
  RequestParamsBaseSchema,
} from './base.js';
import { JurisdictionSchema, MAX_JURISDICTIONS } from '../enums/index.js';

export const GenerateDocumentPayloadSchema = BullMQPayloadBaseSchema.passthrough();
export type GenerateDocumentPayload = z.infer<typeof GenerateDocumentPayloadSchema>;

const GenerateDocumentRequestParamsSchema = RequestParamsBaseSchema.extend({
  selectedDbCaseId: z.string().uuid().optional(),
  useParallelGrokAggregation: z.boolean().optional(),
  skipJurisprudenceResearch: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .optional()
    .describe(
      "User-driven JP skip (lawyer unchecked all jurisdiction checkboxes in the add-in). " +
      "OR'd with the template-based skip list inside the processor. " +
      "Accepts boolean OR string literal 'true'/'false' (FormData stringifies values).",
    ),
  jurisdictions: z
    .array(JurisdictionSchema)
    .max(MAX_JURISDICTIONS)
    .optional()
    .describe(
      "User-selected JP court override (e.g. ['CC', 'CA'] judicial OR " +
      "['CE', 'CAA', 'TA'] administratif). When present, bypasses auto-resolution " +
      "from specialisation in EnhancedJurisprudenceController. Validated against " +
      "the full JurisdictionSchema — invalid codes fail Zod parse and the job is " +
      "rejected. Mirrors the research-only contract. Admin codes added 2026-06-20.",
    ),
}).passthrough();

export const GenerateDocumentJobDataSchema = JobRedisStateBaseSchema
  .extend({
    request_params: GenerateDocumentRequestParamsSchema,
    // `.nullable().optional()` because `JobManager.cleanupJobFiles` writes
    // `file_data: null` explicitly (not `delete`) to free Redis memory —
    // see `services/job_manager.ts:472`. Zod `.optional()` alone rejects
    // `null`, which would break BullMQ retries / crash-safe resumes. The
    // processor handles the cleaned branch via `files_loaded_by_worker:
    // true` (DEBT-067 — A11 skip-completed + JOB_ALREADY_FAILED).
    // Mirrors the same fix on research-only.ts (Path 1).
    file_data: z.record(z.string(), z.unknown()).nullable().optional(),
    files_loaded_by_worker: z.boolean().optional(),
  })
  .passthrough();
export type GenerateDocumentJobData = z.infer<typeof GenerateDocumentJobDataSchema>;
